import React, { useState, useEffect, useMemo } from "react";
import DataTable from "react-data-table-component";
import {
  Button,
  Grid,
  Typography,
  Tooltip,
  FormControl,
  CircularProgress,
  Select,
  MenuItem,
  IconButton,
  Snackbar,
  makeStyles
} from "@material-ui/core";
import Alert from '@material-ui/lab/Alert';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import DetailedScenarioVisualization from "../DetailedScenarioVisualization";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import HistoryIcon from "@material-ui/icons/History";
import LinkOffIcon from '@material-ui/icons/LinkOff';
import LinkIcon from '@material-ui/icons/Link';
import axios from "axios";
import { InsertChart } from "@material-ui/icons";
import KapLinkDailogContent from "./KapLinkDailog";
import Modal from "../../cm_global_modal";
import styled from "styled-components";
import useLoginDeatils from "../../CMCustomHook/useLoginDetails";
import Menu from '@material-ui/core/Menu';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import WebAssetIcon from '@material-ui/icons/WebAsset';
import { createColumnHelper, flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import AlertComponent from '../../../cm_shared/Reporting/AlertBox/AlertComponent'

const customStyles = {
  table: {
    style: {
      border: "solid 1px rgba(0,0,0,.2)",
      borderRadius: "10px",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: 16,
      padding: 20,
      minHeight: "unset"
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      backgroundColor: "#b0ff45",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      fontWeight: "bold",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
  },
};

const StyledDataTable = styled(DataTable)`
  .rdt_TableBody {
    overflow: auto;
    max-height: calc(100vh - 340px)
  }
`;

const loadingStyles = makeStyles({
  wrapper: {
    width: "100%",
    height: "100%",
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: "2",
  },
  spinner: {
    position: "absolute",
    top: "50%",
    left: "50%",
  }
});

const handleNaN = (value, defaultValue = "N/A") => {
  if (value === null || value === undefined) {
    return defaultValue;
  }
  if (typeof value === "number" && Number.isNaN(value)) {
    return defaultValue;
  }
  return value;
};
const remarkType=(remarkList)=>{
  if(typeof remarkList === "string")
    return remarkList

  return <>
          {remarkList && remarkList.map((value)=>{
            const targetValue=value.split(/:(.*)/s);
            const strLength=targetValue.length
            if(strLength<2)
              return <p style={{wordBreak:"break-word"}}>
                      {targetValue[0]}
                     </p>

            return <p style={{wordBreak:"break-word"}}><b>{targetValue[0]}:</b>
                      {' '}{targetValue[1]}
                   </p>
          })}
         </>
}
const ScenarioVariationDetails = ({
  onBack,
  selectedScenario,
  selectedScenarioForDetailedView,
  page,
  isFctw
}) => {
  const query = new URLSearchParams(window.location.search);
  const isReportingMode = query.get("mode") === 'reporting';
  const classes = loadingStyles();
  const [
    selectedTestScenarioDetailedView,
    setSelectedTestScenarioDetailedView,
  ] = useState(null);
  const [issueCatList, setIssueCatList] = useState([]);
  const [parsedData, setParsedData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null)
  const [loading, setloading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: "", severity: "" });
  const [userDetails, setCustomState] = useLoginDeatils("userDetails")


  const afterIssueCatChange = (event, rowIndex, row) => {
    console.log('row index', rowIndex);
    console.log('row', row);

    const updatedIssueCat = event.target.value;
    setParsedData((prevData) => {
      const updatedData = [...prevData];
      updatedData[rowIndex.row.index] = { ...updatedData[rowIndex.row.index], issue_Cat: updatedIssueCat };
      return updatedData;
    });
    if (updatedIssueCat !== '--Select--') {
      updateIssueCat(row.variation_Id, 'issue_cat', updatedIssueCat, rowIndex);
    }


  };

  const updateIssueCat = async (variation_id, updateVal, issueCatValOrKapVal, rowIndex) => {
    const query = new URLSearchParams(window.location.search);
    const execution_id = query.get("execution_id");
    const reporting_level = query.get("reporting_level");
    let payload;
    if (isReportingMode) {
      payload = {
        cad_topology_job_uuid: execution_id,
        logical_uuid: parsedData[0].logical_uuid,
        variation_id
      }
    } else {
      payload = {
        execution_id,
        variation_id,
        reporting_level,
        logical_uuid: parsedData[0].logical_uuid,
      }
      if (reporting_level === 'test_run_id') {
        payload.test_run_id = query.get('test_run_id');
      }
    }
    if (updateVal === 'issue_cat') payload.issue_cat = issueCatValOrKapVal;
    else payload.kap_link = issueCatValOrKapVal;
    setloading(true);

    try {
      const response = await axios.post(
        `/cm/${isReportingMode ? 'reporting-mode' : 'open_loop_pg'}/reporting/fetch-scenario-variation-details`, payload
      );
      setAlert({ open: true, message: "Issue Category updated successfully!", severity: "success" });
      console.log("CAME HERE FOR SUCCESS")
    } catch (error) {
      console.log("IN CATCH")
      console.error("API call failed: ", error);
      const resp = await axios.post(
        `/cm/${isReportingMode ? 'reporting-mode' : 'open_loop_pg'}/reporting/fetch-scenario-variation-details`, payload
      );
      const variationData = resp.data;
      const safeString =
        typeof variationData === "string"
          ? variationData.replace(/NaN/g, "null")
          : JSON.stringify(variationData).replace(/NaN/g, "null");

      const finalData = JSON.parse(safeString);
      const updatedRow = finalData.find((row) => row.variation_Id === variation_id);
      setParsedData((prevData) => {
        const updatedData = [...prevData];
        updatedData[rowIndex] = { ...updatedData[rowIndex], ...updatedRow };
        return updatedData;
      });

      setAlert({ open: true, message: "Failed to update Issue Category. Data refreshed.", severity: "error" });
    }
    updateVal === 'kap_link' && closeKapDailog();
    console.log("Set loading false")
    setloading(false);

  }
  const addKapLink = (content) => {
    setModalContent(content);
    setIsOpen(true);
  }
  const addEnteredKap = (kapLink, variationId) => {
    updateIssueCat(variationId, 'kap_link', kapLink);
  }
  const closeKapDailog = () => {
    setIsOpen(false);
  }
  const openKapLink = (row) => {
    'kap_link' in row && window.open(row.kap_link, '_blank');
  }
  const handleDownload = async (output_file_path) => {
    const fileToDownload = await axios.post(
      "/generate-presigned-url",
      {
        s3_location: output_file_path,
      }
      // { responseType: "blob" }
    );
    window.open(fileToDownload.data.presigned_url);

  };
  const systemType = () => {

    if (window.navigator.platform.indexOf("Win") != -1) {
      return "windows"
    } else if (window.navigator.platform.indexOf("Mac") != -1) {
      return "mac"
    } else if (window.navigator.platform.indexOf("Linux") != -1) {
      return "linux"
    } else {
      return "others"
    }
  }
  const downloadVisualizer = async (outputPath, pageType) => {
    const lambdaPath = process.env.REACT_APP_VISUALIZER_DOWNLOAD
    let payload = {
      data_type: pageType,
      operating_system: systemType()
    }
    isReportingMode ? payload.reporting_mode_output_csv_path = outputPath : payload.execution_mode_output_csv_path = outputPath
    if (pageType == "open_loop")
      payload["open_loop_type"] = "PG"
    try {
      setloading(true)
      const linktoOpenZip = await axios.post(lambdaPath, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })

      handleDownload(linktoOpenZip.data.s3_file_path)
    }
    catch (error) {
      console.error(error)
    } finally {
      setloading(false)
    }
  }
  const DownloadDropDown = ({ pageType, outfilename }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };
    // return <div>KSKSKS</div>
    return (<>
      <Tooltip
        placement="top"
        title={<h6>{"Downloads"}</h6>}
        arrow

      >
        <IconButton
          aria-label="Download"
          style={{ cursor: "pointer", width: "48px", height: "48px" }}
          onClick={handleClick}
        >
          <CloudDownloadIcon />
        </IconButton>
      </Tooltip>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >

        <MenuItem
          onClick={() => {
            handleClose();
            downloadVisualizer(outfilename, pageType);
          }}
        >
          <IconButton
            aria-label="Download-Visualizer"
            style={{ cursor: "pointer", width: "40px", height: "40px" }}
          >
            <WebAssetIcon />
          </IconButton>
          <Typography style={{ display: "inline" }}>
            Visualizer download
          </Typography>
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleClose();
            handleDownload(outfilename)
          }}
        >
          <IconButton
            aria-label="download"
            style={{ cursor: "pointer", width: "40px", height: "40px" }}
          >
            <CloudDownloadIcon />
          </IconButton>
          <Typography style={{ display: "inline" }}>
            Download Output
          </Typography>
        </MenuItem>
      </Menu>
    </>
    );


  }
  const openVisualizer = async (outputPath, username) => {
    // const { data } = await axios.get("/api/user/cp/wrt");
    // console.log('useername', data.username);
    let payload = {
      username: username ? username.trim() : null,
    }
    isReportingMode ? payload.reporting_mode_output_path = outputPath : payload.execution_mode_output_path = outputPath;
    try {
      const linkToOpenResponse = await axios.post("/generate-appstream-link", payload);
      window.open(linkToOpenResponse.data.StreamingURL);
    } catch (error) {
      setAlert({ open: true, message: "Something went wrong. Please try after sometime.", severity: "error" });
    }
  };

  const columnHelper = createColumnHelper()
  const columns = [
    columnHelper.accessor('variation_Id', {
      id: "variation_Id",
      header: "Variation",
      cell: info => {
        const value = info.getValue();
        const row = info.row.original;
        return (
          <>
            <span style={{fontWeight:"bold"}}>{value.replace(
              new RegExp(`^${row.logical_uuid + "_"}`),
              ""
            ) == ""
              ? value
              : value.replace(
                new RegExp(`^${row.logical_uuid + "_"}`),
                ""
              )}
            </span>
            <br />
            {info.row.original.honda_original_name}
          </>
        );
      },
    }),
    columnHelper.accessor('inputParameters', {
      id: "input_parameters",
      header: "Input Parameters",
      cell: info => {
        const value = info.getValue();
        return (
          <>
            {Object.keys(value).map((inputParameter) => {
              if (inputParameter === "Variation") {
                return null;
              }
              return (
                <tr
                  key={inputParameter}
                  style={{
                    marginBottom: "5px",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <td>
                    {inputParameter}:{" "}
                    {handleNaN(value[inputParameter])}
                  </td>
                </tr>
              );
            })}
          </>
        );
      },
    }),
    ...(isFctw ? [columnHelper.group({
      id: "mandatory_target",
      header: "Mandatory Target",
      columns: [
        columnHelper.accessor("mandatory_target.mandatory_target_1", {
          cell: (info) => {
            const value = info.getValue();
            return (
              <span
                style={{
                  textTransform: "uppercase",
                  color:
                    value.result === "PASS"
                      ? "green"
                      : value.result === "FAIL"
                        ? "red"
                        : "grey",
                }}
              >
                {handleNaN(value.KPI)}
                <br />
              </span>
            );
          },
          id: "mandatory_target_mandatory_target_1",
          header: "Mandatory Target 1",
        }),

        columnHelper.accessor("mandatory_target.mandatory_target_2", {
          cell: (info) => {
            const value = info.getValue();
            return (
              <span
                style={{
                  textTransform: "uppercase",
                  color:
                    value.result === "PASS"
                      ? "green"
                      : value.result === "FAIL"
                        ? "red"
                        : "grey",
                }}
              >
                {handleNaN(value.KPI)}
                <br />
              </span>
            );
          },
          id: "mandatory_target_mandatory_target_2",
          header: "Mandatory Target 2",
        }),
        columnHelper.accessor("mandatory_target.mandatory_target_3", {
          cell: (info) => {
            const value = info.getValue();
            return (<span
              style={{
                textTransform: "uppercase",
                color:
                  value.result === "PASS"
                    ? "green"
                    : value.result === "FAIL"
                      ? "red"
                      : "grey",
              }}
            >
              {handleNaN(value.KPI)}
              <br />
            </span>
            );
          },
          id: "mandatory_target_mandatory_target_3",
          header: "Mandatory Target 3",
        }),
        columnHelper.accessor("mandatory_target.mandatory_target_4", {
          cell: (info) => {
            const value = info.getValue();
            return (
              <span
                style={{
                  textTransform: "uppercase",
                  color:
                    value.result === "PASS"
                      ? "green"
                      : value.result === "FAIL"
                        ? "red"
                        : "grey",
                }}
              >
                {handleNaN(value.KPI)}
                <br />
              </span>
            );
          },
          id: "mandatory_target_mandatory_target_4",
          header: "Mandatory Target 4",
        }),
      ],
    }),] : [columnHelper.accessor("mandatory_target", {
      cell: (info) => {
        const row = info.getValue();
        console.log('row val', row);
        console.log(info.getValue());
        return (
          <span
            style={{
              textTransform: "uppercase",
              color:
                row.mandatory_target_1.result === "PASS"
                  ? "green"
                  : row.mandatory_target_1.result === "FAIL"
                    ? "red"
                    : "grey",
            }}
          >
            {handleNaN(row.mandatory_target_1.KPI)}
            <br />
          </span>
        );
      },
      id: "mandatory_target_mandatory_target_1",
      header: "Mandatory Target",
    }),]),

    ...(!isFctw ? [columnHelper.accessor('development_target', {
      id: "development_target",
      header: "Development Target",
      cell: info => {
        const row = info.row.original;
        return (
          <span
            style={{
              textTransform: "uppercase",
              color: row.development_target.result === "PASS" ? "green" : row.development_target.result === "FAIL" ? "red" : "grey",
            }}
          >
            {handleNaN(row.development_target.KPI)}
          </span>
        );
      },
    }),] : []),
    columnHelper.accessor('remarks', {
      id: "remarks",
      header: "Remarks",
      grow: page === 'open_loop' ? 1 : 3,
      cell: info => {
        const row = info.row.original;
        if (row.remarks === null) {
          return (
            handleNaN(row.remarks)
          )
        } else {
          return (
            <>
              {typeof row.remarks === "string" && typeof row.remarks !== 'object' ? (
                handleNaN(row.remarks)
              ) : (
                <div style={{ display: "flex", gap: "2px", justifyContent: "center", flexDirection: "column", minHeight: "150px" }}>
                  <div><p><b>Mandatory</b></p> {remarkType(handleNaN(row.remarks.mandatory_target_remark))}</div>
                  {!isFctw && <div><p><b>
                    Development</b></p><span
                    style={{wordBreak:"break-word"}}> {handleNaN(row.remarks.development_target_remark)}</span>
                  </div>
                  }
                  <div><p><b>Overall</b></p> 
                  <span style={{wordBreak:"break-word"}}> {handleNaN(row.remarks.overall_remarks)}
                  </span> 
                  </div>
                </div>
              )}
            </>
          )
        }
      },
    }),
    ...(page === "open_loop" ? [columnHelper.accessor('issue_Cat', {
      id: "issue_Cat",
      header: "Issue Category",
      width: 125,
      cell: info => {
        const row = info.row.original;
        return (
          <div style={{ pointerEvents: "auto" }} >
            <FormControl
              variant="outlined"
              style={{ width: 125, position: 'relative', left: '1rem' }}
            >
              <Select value={row.issue_Cat !== null && row.issue_Cat !== 'Null' ? row.issue_Cat : '--Select--'} onChange={(e) => afterIssueCatChange(e, info, row)}>
                {issueCatList.map((option) => (
                  <MenuItem key={option._id} value={option.value}>
                    {option.value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        );
      },
      ignoreRowClick: true
    }),] : []),
    ...(page === "open_loop" ? [columnHelper.accessor('situation_Cat', {
      id: "situation_Cat",
      header: "Situation Category",
      width: 100,
      cell: info => {
        const row = info.row.original;
        return (
          <span style={{ position: 'relative', left: '3rem' }}>
            {row.situation_Cat}
          </span>
        );
      },
    }),] : []),
    columnHelper.accessor('actions', {
      id: "actions",
      header: "Action",
      cell: info => {
        const row = info.row.original;
        return (
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            {/* <Tooltip placement="top" title={<h6>Download Output</h6>}>
              <IconButton
                aria-label="download"
                onClick={() => handleDownload(row.output_file_path)}
              >
                <CloudDownloadIcon />
              </IconButton>
            </Tooltip> */}
            <Tooltip placement="top" title={<h6>Visualizer</h6>} style={{ padding: 0 }}>
              <IconButton
                aria-label="download"
                onClick={() => openVisualizer(row.output_file_path, userDetails.email_id)}
              >
                <InsertChart />
              </IconButton>
            </Tooltip>
            {page === 'open_loop' &&
              <>{!row.kap_link && <Tooltip placement="top" title={<h6>Link KAP</h6>}>
                <IconButton
                  aria-label="linkOff"
                  onClick={() =>
                    addKapLink(
                      <KapLinkDailogContent
                        closeKapDailog={closeKapDailog}
                        afterEnteringKapLink={(kapVal, varIdVal) => addEnteredKap(kapVal, varIdVal)}
                        varId={row.variation_Id}
                      />
                    )}
                >
                  <LinkOffIcon />
                </IconButton>
              </Tooltip>}
                {row.kap_link && <Tooltip placement="top" title={<h6>Open KAP link</h6>}>
                  <IconButton
                    aria-label="linkOn"
                    onClick={() => openKapLink(row)}
                  >
                    <LinkIcon />
                  </IconButton>
                </Tooltip>}</>}
            <DownloadDropDown pageType={page} outfilename={row.output_file_path} />
          </div>
        );
      },
    }),
  ];

  if (selectedTestScenarioDetailedView) {
    return (
      <DetailedScenarioVisualization
        testScenario={selectedTestScenarioDetailedView}
        onBack={() => setSelectedTestScenarioDetailedView(null)}
      />
    );
  }
  console.log(
    "RECEIVED==================",
    selectedScenarioForDetailedView,
    typeof selectedScenarioForDetailedView
  );

  // Replace NaN with null
  const formatParsedData = () => {
    try {
      const safeString =
        typeof selectedScenarioForDetailedView === "string"
          ? selectedScenarioForDetailedView.replace(/NaN/g, "null")
          : JSON.stringify(selectedScenarioForDetailedView).replace(
            /NaN/g,
            "null"
          );
      setParsedData(JSON.parse(safeString));
    } catch (error) {
      console.error("Failed to parse selectedScenarioForDetailedView", error);
      setParsedData([]);
    }
  }

  const getIssueCatList = async () => {
    const res = await axios.post('/cm/close_loop/pr_issue_cat');
    let arr = res.data;
    arr.unshift({
      key: "0",
      value: "--Select--",
    })
    setIssueCatList(arr);
  }
  useEffect(() => {
    console.log("LINE 433")
    getIssueCatList();
    formatParsedData()
  }, []);

  useEffect(() => {
    console.log("Scrolling to top")

    window.scrollTo(0, 0);
  }, []);
  // console.log("FINAL PARSED DATA", parsedData, typeof parsedData);

  // const handleCloseAlert = () => {
  //   setAlert({ open: false, message: "", severity: "" });
  // };
  // const AlertFeedback = () => (
  //   <Snackbar
  //     open={alert.open}
  //     autoHideDuration={3000}
  //     onClose={handleCloseAlert}
  //     anchorOrigin={{ vertical: 'top', horizontal: 'center' }} // Positioning for the Snackbar
  //   >
  //     <Alert onClose={handleCloseAlert} severity={alert.severity}>
  //       {alert.message}
  //     </Alert>
  //   </Snackbar>
  // );
  const AlertBoxFeedBack = ({ alert }) => (<>
    {alert.message && <AlertComponent severity={alert.severity == 'error' ? false : true} text={alert.message} />}
  </>)
  const AlertBoxContainer = useMemo(() => alert.message && <AlertBoxFeedBack alert={alert} />, [alert])
  const table = useReactTable({
    data: parsedData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div style={{ padding: "30px" }}>
      {loading && (
        <div className={classes.wrapper}>
          <CircularProgress size={50} className={classes.spinner} />
        </div>
      )}
      {AlertBoxContainer}
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Button
            onClick={onBack}
            variant="contained"
            style={{
              backgroundColor: "#622AD8",
              color: "white",
              "&:hover": {
                backgroundColor: "#303f9f",
              },
              marginBottom: "10px",
            }}
          >
            Back
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        style={{
          marginTop: "30px",
          backgroundColor: "white",
          padding: "1%",
          border: "solid 1px rgba(0,0,0,.2)",
          borderRadius: "10px",
        }}
      >
        <Typography variant="h5" style={{ marginBottom: "10px" }}>
          Selected Scenario -{" "}
          {parsedData.length > 0 ? parsedData[0].logical_uuid : "N/A"}
        </Typography>
        {/* {parsedData.length > 0 && parsedData[0].honda_original_name !== '' ?

          <Grid
            container>
            <Typography Typography variant="h5" style={{ marginBottom: "10px" }}>

              Honda Original Name - {" "}
              {parsedData.length > 0 ? parsedData[0].honda_original_name : "N/A"}</Typography></Grid>
          : null} */}
        {/* <StyledDataTable
          columns={columns}
          data={parsedData}
          defaultSortAsc={true}
          setFilter
          customStyles={customStyles}
          loading={loading}
          keyField="variation_Id"
        />} */}
        <div style={{ width: "100%" , maxHeight: "calc(100vh - 265px)", overflow:"auto"}}>
          <table
            style={{
              border: "solid 1px rgba(0,0,0,5)",
              width: "100%",
              borderRadius: "50px"
            }}
          >
            <thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    return (
                      <th
                        key={header.id}
                        colSpan={header.colSpan}
                        style={{
                          position: "sticky",
                          top: "0",
                          borderBottom: "solid 3px rgba(0,0,0,5)",
                          background: "#B0FF45",
                          color: "rgba(0,0,0,1)",
                          fontWeight: "bold",
                          textAlign: "center",
                          padding: "15px",
                          borderRight: "1px solid rgba(0,0,0,5)",
                          zIndex:10,
                          width:header.column.columnDef.header.toUpperCase()==="REMARKS"?"600px":"auto"
                        }}
                      >
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            <tbody>
              {table.getRowModel().rows.map(row => (
                <tr key={row.id} style={{ border: "solid 1px rgba(0,0,0,5)"}}>
                  {row.getVisibleCells().map(cell => (
                    <td key={cell.id} style={{ padding: "10px"}}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Grid>
      <Modal
        title={"Enter KAP Link Detail"}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        content={modalContent}
        size={"sm"}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        heightVal={'200px'}
      />
    </div >
  );
};

export default ScenarioVariationDetails;
